module.exports = __webpack_public_path__ + "img/shipo-sales-plan-icon-upload.7180f620.svg";